import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4EBC73",
      "fill-rule": "evenodd",
      stroke: "#4EBC73",
      "stroke-linecap": "round",
      "stroke-width": ".917",
      d: "M6.111 2.44a.611.611 0 0 0 0 1.222h8.556a.611.611 0 0 0 0-1.223H6.11Zm0 3.666a.61.61 0 0 0-.611.611V18.94c0 .338.274.612.611.612h6.111a4.278 4.278 0 0 0 0-8.556h-5.5V7.328h7.945a.611.611 0 0 0 0-1.222zm.611 6.111v6.111h5.5a3.056 3.056 0 1 0 0-6.11z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }